import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  TableSortLabel,
  Typography,
  Card,
} from "@mui/material";
import complete from "../../assets/images/payment/CheckCircle.png";
import fail from "../../assets/images/payment/fail.png";
import useWindowSize from "../../hooks/useWindowSize";
import { get } from "../../services/apiService";
import CircularLoader from "../../components/common/ScreenLoader";
import { format } from 'date-fns';



const PaymentHistory = () => {
  // const initialData = [
  //   {
  //     name: "Ibrahim",
  //     transactionId: "TR-009-123456",
  //     date: "2015-10-24",
  //     amount: "SAR79",
  //     status: "Failed",
  //   },
  //   {
  //     name: "Abdullah",
  //     transactionId: "TR-009-123456",
  //     date: "2015-10-24",
  //     amount: "SAR79",
  //     status: "Completed",
  //   },
  //   {
  //     name: "Ahmad",
  //     transactionId: "TR-009-123456",
  //     date: "2015-12-18",
  //     amount: "SAR150",
  //     status: "Completed",
  //   },
  //   {
  //     name: "Alhadid",
  //     transactionId: "TR-009-123456",
  //     date: "2016-10-08",
  //     amount: "SAR250",
  //     status: "Completed",
  //   },
  //   {
  //     name: "Ibrahim",
  //     transactionId: "TR-009-123456",
  //     date: "2017-06-15",
  //     amount: "SAR79",
  //     status: "Failed",
  //   },
  //   {
  //     name: "Rafeh",
  //     transactionId: "TR-009-123456",
  //     date: "2019-01-12",
  //     amount: "SAR150",
  //     status: "Failed",
  //   },
  //   {
  //     name: "Abdullah",
  //     transactionId: "TR-009-123456",
  //     date: "2020-07-21",
  //     amount: "SAR250",
  //     status: "Completed",
  //   },
  //   {
  //     name: "Sabir",
  //     transactionId: "TR-009-123456",
  //     date: "2019-01-12",
  //     amount: "SAR150",
  //     status: "Completed",
  //   },
  //   {
  //     name: "Anas",
  //     transactionId: "TR-009-123456",
  //     date: "2020-07-21",
  //     amount: "SAR250",
  //     status: "Failed",
  //   },
  //   {
  //     name: "Saleha",
  //     transactionId: "TR-009-123456",
  //     date: "2019-01-12",
  //     amount: "SAR150",
  //     status: "Failed",
  //   },
  //   {
  //     name: "Zain Malik",
  //     transactionId: "TR-009-123456",
  //     date: "2020-07-21",
  //     amount: "SAR250",
  //     status: "Completed",
  //   },
  // ];

  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [rowsLength, setRowsLength] = useState([]);
  const { width } = useWindowSize();
  // const [search, setSearch] = useState("");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(true);

  // Handle Search
  const handleSearch = (event) => {
    if (event.target.value === "") {
      setRows(allRows);
    } else {
      const filteredRows = rows.filter(
        (row) =>
          row?.transactionId.includes(event.target.value.toLowerCase()) ||
          row?.transactionStatus
            ?.toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          row?.cardNumber?.includes(event.target.value) ||
          row?.phone?.includes(event.target.value) ||
          row?.amount?.includes(event.target.value) ||
          row?.planStartDate?.includes(event.target.value) ||
          row?.planEndDate.includes(event.target.value) ||
          row?.paymentMethod?.toLowerCase().includes(event.target.value.toLowerCase()) ||
          row?.fullName?.toLowerCase().includes(event.target.value.toLowerCase()) ||
          row?.city?.toLowerCase().includes(event.target.value.toLowerCase()) ||
          row?.email?.toLowerCase().includes(event.target.value.toLowerCase()) 
      );
      setRows(filteredRows);
    }
  };

  // Handle Sorting
  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);

    const sortedRows = [...rows].sort((a, b) => {
      if (isAscending) {
        return a[property] > b[property] ? 1 : -1;
      }
      return a[property] < b[property] ? 1 : -1;
    });
    setRows(sortedRows);
  };

  // Handle Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getFormattedDate = (dateString) => {
    const date = new Date(dateString);

    // Convert to local date and time
    const formattedDate = date.toLocaleString("en-US", {
      year: "numeric",
      month: "long", // "short" for abbreviated month
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Set to false for 24-hour format
    });
    return formattedDate;
  };

  useEffect(() => {
    fetchPayments();
  }, [page, order, rowsPerPage]);

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const formatDate = (isoDate) => {


    const formattedDate = format(new Date(isoDate), "MMMM dd, yyyy, h:mm a");
    return formattedDate;
  }

  const fetchPayments = useCallback(async () => {
    const response = await get(
      `payments?order=${order.toUpperCase()}&page=${page + 1}&take=${rowsPerPage}`,
      {},
      onLoading
    );
    if (response?.status === 200) {
      const payments = response.data.data;
      console.log('payments--------->', payments);
      const updatedPayments = payments.map(payment=>{
        return {
          transactionId:payment.transactionId,
          transactionDate:payment.transactionDate,
          cardNumber:payment.cardNumber,
          transactionStatus:payment.transactionStatus,

          fullName:payment.user.fullName,
          email:payment.user.email,
          city:payment.user.city,
          phone:payment.user.phoneNumber,
          amount:payment.amount,
          // planName:payment.userPlan.planPriceType,
          paymentMethod:payment.paymentMethod,
          selectedPlanPrice:Number(payment?.userPlan?.total),
          subscriptionType:payment?.userPlan?.planPriceType,
          planStartDate:payment?.userPlan?.planStartDate ? formatDate(payment?.userPlan?.planStartDate) : "",
          planEndDate:payment?.userPlan?.planEndDate ? formatDate(payment?.userPlan?.planEndDate) : "",
          planDuration:payment.userPlan?.subscriptionDuration
        }
      })
      console.log('updated payments--------->', updatedPayments);
      const totalPaymentRecords = response.data.meta.itemCount;
      setRowsLength(totalPaymentRecords);
      setAllRows(updatedPayments);
      setRows(updatedPayments);
    }
  }, [order, page, rowsPerPage]);

  return (
    <Box sx={{ p: width > 450 ? 3 : 1 }}>
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // Distribute items to both ends
          p: 2,
          marginBottom: "2%",
        }}
      >
        {/* Left-Aligned Heading */}
        <Box>
          <Typography
            sx={{
              fontFamily: "Tajawal-Bold",
              color: "#0A0A0A",
              fontSize: width > 900 ? "26px" : "18px",
              fontWeight: 700,
            }}
          >
            Payments
          </Typography>
        </Box>

        {/* Right-Aligned Search Field */}
        <TextField
          variant="outlined"
          placeholder="Search"
          onChange={handleSearch}
          sx={{
            width: width > 600 ? "270px" : "170px", // Set the specific width
            mb: 1,
            borderRadius: "12px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "14px", // Apply border-radius to the input field
              height: "55px",
            },
          }}
        />
      </Card>

      {/* Table */}
      <Paper
        sx={{
          overflow: "hidden",
          borderRadius: 2,
        }}
      >
        <TableContainer sx={{ height: "612px", overflowX: "auto" , maxWidth:"100%" }}>
          <Table>
            <TableHead>
              <TableRow>

                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"100px"
                  }}
                >
                  Customer Name
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"40px"
                  }}
                >
                  Customer Email
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"40px"
                  }}
                >
                  Customer Phone 
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"40px"
                  }}
                >
                                         <TableSortLabel
                    active={orderBy === "city"}
                    direction={orderBy === "city" ? order : "asc"}
                    onClick={() => handleSort("city")}
                  >
                  Customer City
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"150px"
                  }}
                >
                         <TableSortLabel
                    active={orderBy === "planStartDate"}
                    direction={orderBy === "planStartDate" ? order : "asc"}
                    onClick={() => handleSort("planStartDate")}
                  >
                   Plan Start Date
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"150px"
                  }}
                >
                                         <TableSortLabel
                    active={orderBy === "planEndDate"}
                    direction={orderBy === "planEndDate" ? order : "asc"}
                    onClick={() => handleSort("planEndDate")}
                  >
                   Plan End Date
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"40px"
                  }}
                >
                  Plan Duration 
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                    minWidth:"40px"
                  }}
                >
                  Transaction ID
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"150px"
                  }}
                >
                  <TableSortLabel
                    active={orderBy === "transactionDate"}
                    direction={orderBy === "transactionDate" ? order : "asc"}
                    onClick={() => handleSort("transactionDate")}
                  >
                    Transaction Date
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"150px"
                  }}
                >
                  <TableSortLabel
                    active={orderBy === "cardNumber"}
                    direction={orderBy === "cardNumber" ? order : "asc"}
                    onClick={() => handleSort("cardNumber")}
                  >
                    Card Number
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"150px"
                  }}
                >
                  <TableSortLabel
                    active={orderBy === "paymentMethod"}
                    direction={orderBy === "paymentMethod" ? order : "asc"}
                    onClick={() => handleSort("paymentMethod")}
                  >
                    Payment Method
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                     minWidth:"150px"
                  }}
                >
                  <TableSortLabel
                    active={orderBy === "amount"}
                    direction={orderBy === "amount" ? order : "asc"}
                    onClick={() => handleSort("amount")}
                  >
                    Total Amount In SAR
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Tajawal-Bold",
                    fontSize: "12px",
                    fontWeight: 700,
                  }}
                >
                  <TableSortLabel
                    active={orderBy === "transactionStatus"}
                    direction={orderBy === "transactionStatus" ? order : "asc"}
                    onClick={() => handleSort("transactionStatus")}
                  >
                    Status
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow sx={{ height: "500px", width: "100%" }}>
                  <TableCell
                    colSpan={4}
                    sx={{
                      height: "100%",
                      textAlign: "center",
                      py: 2,
                      borderBottom: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularLoader />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : rows.length > 0 ? (
                rows.map((row, index) => (
                  <TableRow key={index} hover>
                    {/* <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      {row.name}
                    </TableCell> */}

                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.fullName}
                    </TableCell>
                                        <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.email}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.phone}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.city}
                    </TableCell>
                                        <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.planStartDate}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.planEndDate}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.subscriptionType === 'monthly' && row.planDuration === 1 ? row.planDuration + ' Month' : row.subscriptionType === 'monthly' && row.planDuration > 1 ? row.planDuration + ' Months' : row.subscriptionType === 'yearly' && row.planDuration === 1 ? row.planDuration + ' Year' :  row.planDuration + ' Years' }
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.transactionId}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {getFormattedDate(row.transactionDate)}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.cardNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.paymentMethod}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Tajawal-Regular",
                        color: "#161919",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {row.amount}
                    </TableCell>
                    <TableCell>
                      {row.transactionStatus === "Succss" ? (
                        <Box
                          sx={{
                            color: "#89D233",
                            background: "#89D2331A",
                            width: "150px",
                            borderRadius: "8px",
                            padding: "10px",
                            display: "flex",
                            textAlign: "center",
                            justifyContent: "center",
                            fontFamily: "Tajawal-Regular",
                          }}
                        >
                          <img src={complete} alt="complete" />
                          <Typography sx={{ marginLeft: "4%" }}>
                            Passed
                          </Typography>
                        </Box>
                      ) : row.transactionStatus === "Failed" ? (
                        <Box
                          sx={{
                            color: "#F27277",
                            background: "#F272771A",
                            width: "150px",
                            borderRadius: "8px",
                            padding: "10px",
                            display: "flex",
                            textAlign: "center",
                            justifyContent: "center",
                            fontFamily: "Tajawal-Regular",
                          }}
                        >
                          <img src={fail} alt="complete" />
                          <Typography sx={{ marginLeft: "4%" }}>
                            Failed
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            color: "#dfcc1e",
                            background: "#f4f7ab59",
                            width: "150px",
                            borderRadius: "8px",
                            padding: "10px",
                            display: "flex",
                            textAlign: "center",
                            justifyContent: "center",
                            fontFamily: "Tajawal-Regular",
                          }}
                        >
                          {/* <img src={fail} alt="complete" /> */}
                          <Typography sx={{ marginLeft: "4%" }}>
                            Pending
                          </Typography>
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow sx={{ height: "500px", width: "100%" }}>
                  <TableCell
                    colSpan={4}
                    sx={{
                      height: "100%",
                      textAlign: "center",
                      py: 2,
                      borderBottom: "none",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            textAlign: "center",
                            fontFamily: "Tajawal-Bold",
                            fontWeight: 600,
                            fontSize: "24px",
                          }}
                        >
                          Payment list is empty.
                        </Typography>
                        <Typography
                          sx={{
                            marginTop: "1%",
                            textAlign: "center",
                            fontFamily: "Tajawal-Bold",
                            fontWeight: 700,
                            fontSize: "22px",
                            color: "#00000099",
                          }}
                        >
                          In the payment list, you will get the information
                          related to failed or passed transactions.
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        {rows.length > 0 && (
          <TablePagination
            component="div"
            count={rowsLength}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // showLastButton={true}
          />
        )}
      </Paper>
    </Box>
  );
};

export default PaymentHistory;
